import { CreateReasonStep1 } from '@modules/common/components/CreateNewReasonForm/CreateReasonStep1';
import { CreateReasonStep2 } from '@modules/common/components/CreateNewReasonForm/CreateReasonStep2';
import { ReasonDefinition } from '@modules/taxonomyV2/store/types';
import { Stack } from '@mui/material';
import { Category, Rc } from 'generated/graphql';
import { useState } from 'react';

interface CreateReasonFormProps {
  onCompleted: (createdReason: {
    id: string;
    displayName: string;
    category: Category;
  }) => Promise<void> | void;
  onCancel: () => void;
  prompt: string;
  onPromptChange: (prompt: string) => void;
  selectedFeedbackRecordID?: string;
  selectedReasonDefinitions?: Rc[];
  isLoading?: boolean;
}

export const CreateNewReasonForm = ({
  onCancel,
  onCompleted,
  prompt,
  selectedFeedbackRecordID,
  selectedReasonDefinitions = [],
  onPromptChange,
  isLoading = false,
}: CreateReasonFormProps) => {
  const [step, setStep] = useState(0);
  const [reasonName, setReasonName] = useState('');
  const [reasonDefinitions, setReasonDefinitions] = useState<
    ReasonDefinition[]
  >([]);
  const [reasonCategory, setReasonCategory] = useState<Category>(
    Category.Issue,
  );

  return (
    <Stack sx={{ p: 2, height: '100%' }}>
      {step === 0 ? (
        <CreateReasonStep1
          prompt={prompt}
          selectedFeedbackRecordID={selectedFeedbackRecordID}
          selectedReasonDefinitions={selectedReasonDefinitions}
          onPromptChange={onPromptChange}
          onCancel={onCancel}
          onCompleted={({ category, reasonName, reasonDefinitions }) => {
            setReasonName(reasonName);
            setReasonCategory(category);
            setReasonDefinitions(reasonDefinitions);
            setStep(1);
          }}
        />
      ) : (
        <CreateReasonStep2
          prompt={prompt}
          reasonName={reasonName}
          reasonCategory={reasonCategory}
          reasonDefinitions={reasonDefinitions}
          onReasonNameChange={setReasonName}
          onReasonCategoryChange={setReasonCategory}
          onReasonDefinitionsChange={setReasonDefinitions}
          onPromptEdit={() => setStep(0)}
          onCancel={onCancel}
          onCompleted={onCompleted}
          isLoading={isLoading}
        />
      )}
    </Stack>
  );
};
